import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const PlantLayoutEditor = React.lazy(() => import('.'));

export const plantLayoutEditorRoutes = [
  new Route({
    path: 'plant-layout-editor',
    element: PlantLayoutEditor,
    children: [],
  }),
];
